import React from 'react';
import { Card, Col, Row } from 'antd';
import Header from '../../components/Header';
import { Wrapper } from './styles';
import HeaderNavigation from '../../components/HeaderNavigation';
import { TripSummaryWrapper } from '../SearchRoadListings/styles';
import SeatSelection from '../../components/SeatSelection/TrainSeatSelection';
import { GiveMeSpace } from '../../components/CustomAntdComponents/Utitlities';
import { StyledTitle } from '../../components/CustomAntdComponents/Typography';
import RailTripSummary from '../../components/TripSummary/RailTripSummary';
import TrainItinerary from '../../components/TrainItinerary';
import { useI18nContext } from '../../utils/I18n';
import translations from '../PassengerDetails/translations';

function TrainSeatSelection() {
  const {
    state: { t },
  } = useI18nContext();
  return (
    <>
      <Row>
        <Col xs={0} lg={24}>
          <Header />
        </Col>
      </Row>

      <div className="container">
        <Wrapper>
          <Row>
            <Col xs={24} lg={0}>
              <HeaderNavigation name="Seat Selection" />
            </Col>
            <Col xs={0} lg={24}>
              <HeaderNavigation />
            </Col>
          </Row>

          <Row gutter={32}>
            <Col xs={24} lg={0}>
              <Card size="small">
                <TripSummaryWrapper>
                  <RailTripSummary />
                </TripSummaryWrapper>
              </Card>
              <GiveMeSpace />
            </Col>
            <Col xs={24} lg={16}>
              <StyledTitle level={4}>
                {t(translations).seatSelectionTitle}
              </StyledTitle>
              <GiveMeSpace />
              <SeatSelection />
            </Col>
            <Col xs={0} lg={8}>
              <StyledTitle level={4}>
                {t(translations).itineraryTitle}
              </StyledTitle>
              <GiveMeSpace />
              <TrainItinerary showSubmitButton={false} />
            </Col>
          </Row>
        </Wrapper>
      </div>
    </>
  );
}

export default TrainSeatSelection;
